import { render, staticRenderFns } from "./PractitionerAppointments.vue?vue&type=template&id=edecd456&scoped=true&"
import script from "./PractitionerAppointments.vue?vue&type=script&lang=js&"
export * from "./PractitionerAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edecd456",
  null
  
)

export default component.exports